(function () {
    let queue = [];
    let initialized = false;
    let frequency = 100;
    let timeout = 200 * frequency; // 2 seconds`

    function process() {
        if (!initialized) {
            return;
        }
        let action = null;
        while (action = queue.shift()) action();
    }

    let view = function (data) {
        debugObject(data);
        queue.push(function () {
            window.utag.view(data);
        });
        process();
    };

    let link = function (data) {
        debugObject(data);
        queue.push(function () {
            window.utag.link(data);
        });
        process();
    };

    window.tagUtil = {
        view: view,
        link: link
    };

    (function run() {
        window.setTimeout(function () {
            if ("utag" in window && "view" in window.utag && "link" in window.utag) {
                initialized = true;
                timeout = 0;
                process();
            }

            timeout -= frequency;

            if (timeout > 0) {
                run();
            }
        }, frequency);
    })();
})();

function debugObject(obj) {
    if (console.table) {
        console.table(obj);
    } else {
        console.debug(JSON.stringify(obj, null, 2));
    }
}